// extracted by css-extract-rspack-plugin
export default {"kpiRow":"xY663GvLzpwjNXg8","kpiLabel":"x3G0BFpDbYbJThOd","kpiValue":"fYtdNqLKIBwAvqs9","kpiCaption":"M_g3bJHC50axTsNP"};